import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'shared-user-status-badge',
  standalone: false,
  template: ` <nz-tag [nzColor]="color"> {{ label | translate }} </nz-tag>`,
})
export class UserStatusBadgeComponent implements OnChanges {
  @Input() status: 'Active' | 'Pending';

  color?: string | undefined;
  label: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.setColor();
    this.setLabel();
  }

  setColor() {
    if (this.status === 'Active') {
      this.color = 'green';
      return;
    }
    
    if (this.status === 'Pending') {
      this.color = 'yellow';
      return;
    }

    this.color = undefined;
  }

  setLabel() {
    this.label = `Portal.InspectionCompanies.Users.${this.status}.Label`
  }
}
